import script from "./zs-manage-person.vue?vue&type=script&lang=tsx&setup=true"
export * from "./zs-manage-person.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__